// extracted by mini-css-extract-plugin
export default {"recos":"k5-z","productCardOverride":"l5-z","rowHasBadge":"m5-z"};